package dev.kuml.portal.web.i18n

import dev.kuml.portal.web.i18n.format.LocaleFormat
import dev.kuml.portal.web.i18n.format.LocaleFormatDe
import dev.kuml.portal.web.i18n.format.LocaleFormatEn
import dev.kuml.portal.web.i18n.strings.ActivityStrings
import dev.kuml.portal.web.i18n.strings.ActivityStringsDe
import dev.kuml.portal.web.i18n.strings.ActivityStringsEn
import dev.kuml.portal.web.i18n.strings.AuthStrings
import dev.kuml.portal.web.i18n.strings.AuthStringsDe
import dev.kuml.portal.web.i18n.strings.AuthStringsEn
import dev.kuml.portal.web.i18n.strings.CommonStrings
import dev.kuml.portal.web.i18n.strings.CommonStringsDe
import dev.kuml.portal.web.i18n.strings.CommonStringsEn
import dev.kuml.portal.web.i18n.strings.EditorStrings
import dev.kuml.portal.web.i18n.strings.EditorStringsDe
import dev.kuml.portal.web.i18n.strings.EditorStringsEn
import dev.kuml.portal.web.i18n.strings.ErrorStrings
import dev.kuml.portal.web.i18n.strings.ErrorStringsDe
import dev.kuml.portal.web.i18n.strings.ErrorStringsEn
import dev.kuml.portal.web.i18n.strings.HeaderStrings
import dev.kuml.portal.web.i18n.strings.HeaderStringsDe
import dev.kuml.portal.web.i18n.strings.HeaderStringsEn
import dev.kuml.portal.web.i18n.strings.LegalStrings
import dev.kuml.portal.web.i18n.strings.LegalStringsDe
import dev.kuml.portal.web.i18n.strings.LegalStringsEn
import dev.kuml.portal.web.i18n.strings.ProfileStrings
import dev.kuml.portal.web.i18n.strings.ProfileStringsDe
import dev.kuml.portal.web.i18n.strings.ProfileStringsEn
import dev.kuml.portal.web.i18n.strings.ProjectFilesStrings
import dev.kuml.portal.web.i18n.strings.ProjectFilesStringsDe
import dev.kuml.portal.web.i18n.strings.ProjectFilesStringsEn
import dev.kuml.portal.web.i18n.strings.ProjectsStrings
import dev.kuml.portal.web.i18n.strings.ProjectsStringsDe
import dev.kuml.portal.web.i18n.strings.ProjectsStringsEn
import dev.kuml.portal.web.i18n.strings.ShareStrings
import dev.kuml.portal.web.i18n.strings.ShareStringsDe
import dev.kuml.portal.web.i18n.strings.ShareStringsEn
import dev.kuml.portal.web.i18n.strings.UsageStrings
import dev.kuml.portal.web.i18n.strings.UsageStringsDe
import dev.kuml.portal.web.i18n.strings.UsageStringsEn

/**
 * R-18's root i18n interface -- every domain bundle in one place, so `t.<domain>.<key>` reads the
 * same way everywhere in `kuml-portal-web`. See this wave's plan §1.1 for why this
 * interface-plus-two-objects shape was chosen over KVision's own gettext-based `io.kvision.i18n`,
 * a raw `Map<String, String>`, or an enum-keyed `when`: a missing translation is a COMPILE error
 * here (a new property must be implemented by BOTH [StringsDe] and [StringsEn] before the project
 * builds at all), never a silent runtime fallback/placeholder leak.
 */
public interface Strings {
    public val common: CommonStrings
    public val auth: AuthStrings
    public val header: HeaderStrings
    public val projects: ProjectsStrings
    public val projectFiles: ProjectFilesStrings
    public val editor: EditorStrings
    public val profile: ProfileStrings
    public val activity: ActivityStrings
    public val usage: UsageStrings
    public val errors: ErrorStrings
    public val legal: LegalStrings
    public val share: ShareStrings
    public val format: LocaleFormat
}

public object StringsDe : Strings {
    override val common: CommonStrings = CommonStringsDe
    override val auth: AuthStrings = AuthStringsDe
    override val header: HeaderStrings = HeaderStringsDe
    override val projects: ProjectsStrings = ProjectsStringsDe
    override val projectFiles: ProjectFilesStrings = ProjectFilesStringsDe
    override val editor: EditorStrings = EditorStringsDe
    override val profile: ProfileStrings = ProfileStringsDe
    override val activity: ActivityStrings = ActivityStringsDe
    override val usage: UsageStrings = UsageStringsDe
    override val errors: ErrorStrings = ErrorStringsDe
    override val legal: LegalStrings = LegalStringsDe
    override val share: ShareStrings = ShareStringsDe
    override val format: LocaleFormat = LocaleFormatDe
}

public object StringsEn : Strings {
    override val common: CommonStrings = CommonStringsEn
    override val auth: AuthStrings = AuthStringsEn
    override val header: HeaderStrings = HeaderStringsEn
    override val projects: ProjectsStrings = ProjectsStringsEn
    override val projectFiles: ProjectFilesStrings = ProjectFilesStringsEn
    override val editor: EditorStrings = EditorStringsEn
    override val profile: ProfileStrings = ProfileStringsEn
    override val activity: ActivityStrings = ActivityStringsEn
    override val usage: UsageStrings = UsageStringsEn
    override val errors: ErrorStrings = ErrorStringsEn
    override val legal: LegalStrings = LegalStringsEn
    override val share: ShareStrings = ShareStringsEn
    override val format: LocaleFormat = LocaleFormatEn
}
